"use client";

import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className", "type"];
var __jsx = React.createElement;
import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { cn } from "@lib/cn";
import Icons from "@modules/icons";
import useCssModules from "@lib/hooks/use-css-modules";
const Checkbox = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      className,
      type
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    cssModules
  } = useCssModules(); // ADD TYPE PROPS IN LIBRARY (type1, type2, type3)
  const {
    checkboxBase,
    checkboxIcon
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.checkbox) || {};
  return __jsx(CheckboxPrimitive.Root, _extends({
    ref: ref,
    className: cn(checkboxBase, className)
  }, props), __jsx(CheckboxPrimitive.Indicator, {
    className: cn("flex items-center justify-center text-current")
  }, __jsx(Icons.checkboxCheck, {
    className: checkboxIcon
  })));
});
export { Checkbox };